// @index('./*', pp => `export * from "${pp.path}";`)
export * from './ExtendedPropertyType';
export * from './IExtendedProperty';
export * from './IExtendedPropertyDbRow';
export * from './IExtendedPropertyQuery';
export * from './TExtendedPropertyDeleteParams';
export * from './TExtendedPropertyDeleteRequest';
export * from './TExtendedPropertyGetParams';
export * from './TExtendedPropertyGetResponse';
export * from './TExtendedPropertyListRequest';
export * from './TExtendedPropertyListResponse';
export * from './TExtendedPropertyUpsertRequest';
export * from './TExtendedPropertyUpsertResponse';
export * from './TExtendedPropertyValue';
